
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-gray-300 py-10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-4">
          <a href="https://www.nfz.gov.pl/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors mx-2">Narodowy Fundusz Zdrowia</a>
          <span className="text-gray-500">|</span>
          <a href="https://www.gov.pl/web/zdrowie" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors mx-2">Ministerstwo Zdrowia</a>
        </div>
        <p className="text-sm">
          &copy; {currentYear} Dentobus Wielkopolska NFZ. Wszelkie prawa zastrzeżone.
        </p>
        <p className="text-xs mt-2 text-gray-400">
          Strona ma charakter informacyjny. Po szczegółowe informacje zapraszamy do kontaktu z naszym koordynatorem.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
